import { CSSProperties, FC, useState } from "react";
import { defineMessages, useIntl } from "react-intl";
import { IButtonStyles, IconButton } from "@fluentui/react";
import { domUtils } from "cayo.ui";
import styled from "styled-components";

interface ICopyButton {
  onClick: () => void;
  isAbsolutePosition?: boolean;
  isInsideCopyContainer?: boolean;
  hasBackground?: boolean | undefined;
  style?: CSSProperties;
  disabled?: boolean;
}

const CopyButton: FC<ICopyButton> = ({
  onClick,
  isAbsolutePosition,
  isInsideCopyContainer,
  hasBackground,
  style,
  disabled,
}) => {
  const intl = useIntl();
  const [isCopied, setIsCopied] = useState(false);

  const styles = {
    ...(!hasBackground && noBackgroundStyle),
    root: style as {},
  };

  return (
    <CopyButtonContainer
      additionalStyle={style}
      btnAbsPositionStyle={isAbsolutePosition ? btnAbsPositionStyle : {}}
    >
      <IconButton
        className={isInsideCopyContainer ? "copy-button" : undefined}
        iconProps={{ iconName: "Copy" }}
        title={isCopied ? intl.formatMessage(messages.copied) : intl.formatMessage(messages.copy)}
        onClick={(e) => {
          domUtils.stopMouseDown(e);
          onClick();
          setIsCopied(true);
        }}
        onDoubleClick={domUtils.stopMouseDown}
        styles={styles}
        disabled={disabled}
        onMouseEnter={domUtils.stopMouseDown}
        onMouseDown={domUtils.stopMouseDown}
      />
    </CopyButtonContainer>
  );
};

const messages = defineMessages({
  copy: {
    defaultMessage: "Copy to clipboard",
    id: "copy-btn.copy-to-clipboard",
  },
  copied: {
    defaultMessage: "Copied to clipboard",
    id: "copy-btn.copied-to-clipboard",
  },
});

const noBackgroundStyle: IButtonStyles = {
  rootHovered: { background: "none" },
  rootPressed: { background: "none" },
};

const btnAbsPositionStyle: CSSProperties = { position: "absolute" };

const CopyButtonContainer = styled.div<{
  additionalStyle?: CSSProperties;
  btnAbsPositionStyle: CSSProperties;
}>`
  display: flex;
  align-items: center;
  right: 0px;
  ${(props) => ({ ...props.additionalStyle })};
  ${(props) => ({ ...props.btnAbsPositionStyle })};
`;

export default CopyButton;
